import React from "react";
import { Box, SpaceBetween, Badge } from "@cloudscape-design/components";
import { BadgeColor } from "src/constants/reportConstants";

interface FiltersDisplayProps {
  filters: Record<string, string[]>;
  labelWidth?: string;
  title?: string;
}

/**
 * Displays applied filters in a structured format with badges
 * @param filters - Object mapping filter names to their selected values
 * @param labelWidth - Width of filter labels
 * @param title - Section title
 */
export const FiltersDisplay: React.FC<FiltersDisplayProps> = ({ 
  filters, 
  labelWidth = "120px",
  title = "Filters"
}) => (
  <Box>
    <Box variant="h3" margin={{ bottom: "s" }}>{title}</Box>
    <SpaceBetween direction="vertical" size="xs">
      {Object.entries(filters).map(([key, values]) => (
        <SpaceBetween key={key} direction="horizontal" size="s">
          <div style={{ minWidth: labelWidth }}>
            <Box variant="strong" fontSize="body-s">
              {key}:
            </Box>
          </div>
          <SpaceBetween direction="horizontal" size="xs">
            {values.map((value, index) => (
              <Badge key={index} color={BadgeColor.SEVERITY_NEUTRAL}>
                {value}
              </Badge>
            ))}
          </SpaceBetween>
        </SpaceBetween>
      ))}
    </SpaceBetween>
  </Box>
);
